/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VoucherStatus } from './voucher-status';
import { VoucherCittadinoBandoMinDTO } from './voucher-cittadino-bando-min-dto';


export interface VoucherCittadinoDTO { 
    id?: string;
    codice?: string;
    importo_totale?: number;
    importo_residuo?: number;
    status?: VoucherStatus;
    scadenza?: string;
    /**
     * true se scadenza < now (scadenza lazy: lo status resta invariato)
     */
    scaduto?: boolean;
    bando?: VoucherCittadinoBandoMinDTO;
    /**
     * true se il PDF+QR è disponibile per il download: mai su un voucher ASSEGNATO (non ancora consegnato, quindi non spendibile e senza scadenza)
     */
    pdf_disponibile?: boolean;
    /**
     * true se il bando abilita l\'elenco esercenti E il voucher e\' spendibile (DA_CONSUMARE/PARZIALMENTE_CONSUMATO) e non scaduto: abilita GET /{id}/esercenti
     */
    elenco_esercenti_disponibile?: boolean;
    /**
     * Data della revoca del Comune, solo su un voucher ANNULLATO (senza motivo ne\' operatore)
     */
    data_revoca?: string;
}



